import { styled } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

const FilterCancelIcon = styled(CancelIcon, {
    name: "StyledCancelIcon",
    slot: "Wrapper",
})({
    color: "#586A84",
    opacity: "0.45",
    "&:hover": { color: "#586A84", opacity: "0.9" },
});

export default FilterCancelIcon;
